import {
  CashIcon,
  CubeIcon,
  CurrencyDollarIcon,
  DocumentDuplicateIcon,
  LocationMarkerIcon,
  MapIcon,
  NewspaperIcon,
  OfficeBuildingIcon,
  TemplateIcon,
  UserGroupIcon,
  TableIcon,
  DocumentReportIcon,
  DocumentTextIcon,
  ClipboardCopyIcon,
  CalculatorIcon,
} from '@heroicons/react/solid';

export enum Widget {
  PROJECT_FINANCIAL = 'PROJECT_FINANCIAL',
  PROJECTS_BY_NEIGHBORHOOD = 'PROJECTS_BY_NEIGHBORHOOD',
  PROJECT_BUDGET_SUMMARY = 'PROJECT_BUDGET_SUMMARY',
  PROJECT_LOCATION = 'PROJECT_LOCATION',
  PROJECT_STATUS_SUMMARY = 'PROJECT_STATUS_SUMMARY',
  PROJECTS_BY_CONSTRUCTION_TYPE = 'PROJECTS_BY_CONSTRUCTION_TYPE',
  PROJECTS_BY_PROJECT_TYPE = 'PROJECTS_BY_PROJECT_TYPE',
  TASKS_COUNT = 'TASKS_COUNT',
  DELIVERABLES_COUNT = 'DELIVERABLES_COUNT',
  MILESTONES_COUNT = 'MILESTONES_COUNT',
  REBUILD_INVENTORY = 'REBUILD_INVENTORY',
  PROJECTS_BY_PROGRAMS = 'PROJECTS_BY_PROGRAMS',
  PROJECTS_BY_SOURCES = 'PROJECTS_BY_SOURCES',
  PROJECTS_BY_USES = 'PROJECTS_BY_USES',
  PROJECTS_BY_NEIGHBORHOOD_DISTRICT = 'PROJECTS_BY_NEIGHBORHOOD_DISTRICT',
  PROJECTS_SUMMARY_REPORT = 'PROJECTS_SUMMARY_REPORT',
  REBUILD_LOANS_APPROVED = 'REBUILD_LOANS_APPROVED',
  TOTAL_DEVELOPERS = 'TOTAL_DEVELOPERS',
  TOTAL_PROJECTS = 'TOTAL_PROJECTS',
  DEVELOPMENT_GOALS_SUMMARY = 'DEVELOPMENT_GOALS_SUMMARY',
  PROJECTS_SPENDING_SUMMARY_REPORT = 'PROJECTS_SPENDING_SUMMARY_REPORT',
  TOTAL_DEPARTMENT_LED_PROJECTS = 'TOTAL_DEPARTMENT_LED_PROJECTS',
  PROJECT_AVERAGE_SALES_PRICE = 'PROJECT_AVERAGE_SALES_PRICE'
}

export enum DashboardName {
  COMPANY_DASHBOARD = 'COMPANY_DASHBOARD',
  SHERPA_DASHBOARD = 'SHERPA_DASHBOARD',
  USER_DASHBOARD = 'USER_DASHBOARD',
  FBDI_DASHBOARD = 'FBDI_DASHBOARD',
}

export const widgetsIcon: { [key: string]: JSX.Element } = {
  REBUILD_INVENTORY: <DocumentDuplicateIcon className='h-5 w-5' />,
  REBUILD_LOANS_APPROVED: <CubeIcon className='h-5 w-5' />,
  TOTAL_DEVELOPERS: <UserGroupIcon className='h-5 w-5' />,
  TOTAL_PROJECTS: <OfficeBuildingIcon className='h-5 w-5' />,
  PROJECT_LOCATION: <LocationMarkerIcon className='h-5 w-5' />,
  PROJECTS_BY_NEIGHBORHOOD: <MapIcon className='h-5 w-5' />,
  PROJECT_BUDGET_SUMMARY: <CashIcon className='h-5 w-5' />,
  PROJECT_FINANCIAL: <CurrencyDollarIcon className='h-5 w-5' />,
  PROJECT_STATUS_SUMMARY: <NewspaperIcon className='h-5 w-5' />,
  PROJECTS_BY_PROJECT_TYPE: <OfficeBuildingIcon className='h-5 w-5' />,
  PROJECTS_BY_CONSTRUCTION_TYPE: <TemplateIcon className='h-5 w-5' />,
  TASKS_COUNT: <TableIcon className='h-5 w-5' />,
  DELIVERABLES_COUNT: <DocumentTextIcon className='h-5 w-5' />,
  MILESTONES_COUNT: <DocumentReportIcon className='h-5 w-5' />,
  TASKS: <TableIcon className='h-5 w-5' />,
  DELIVERABLES: <DocumentTextIcon className='h-5 w-5' />,
  MILESTONES: <DocumentReportIcon className='h-5 w-5' />,
  MINORITY_AND_SOCIAL_GOALS: <UserGroupIcon className='h-5 w-5' />,
  TEAM_EXTERNAL: <UserGroupIcon className='h-5 w-5' />,
  TEAM_INTERNAL: <UserGroupIcon className='h-5 w-5' />,
  CCLF_LOAN: <CashIcon className='h-5 w-5' />,
  SCHEDULE: <ClipboardCopyIcon className='h-5 w-5' />,
  EXECUTION_ANALYSIS: <CalculatorIcon className='h-5 w-5' />,
};
